import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconContextSearch20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconContextSearch20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M1.979 4.75c0 .414.335.75.75.75H16.25a.75.75 0 1 0 0-1.5H2.73a.75.75 0 0 0-.75.75m0 10c0 .414.335.75.75.75h5.107a.75.75 0 0 0 0-1.5H2.729a.75.75 0 0 0-.75.75m12.884-3.569a1.681 1.681 0 1 1-3.363 0 1.681 1.681 0 0 1 3.363 0m1.5 0c0 .606-.17 1.173-.463 1.655l1.31 1.319a.75.75 0 0 1-1.064 1.057l-1.306-1.315a3.181 3.181 0 1 1 1.523-2.716M2.73 10.5a.75.75 0 0 1 0-1.5h4.376a.75.75 0 1 1 0 1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconContextSearch20);
